import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  readEventResourcesList,
  resetEventResourcesList,
  readEventAvailableResourcesList,
  addEventResource,
  deleteEventResource,
} from "src/engine/modules/eventResources/actions/creators"
import {
  selectEventAvailableResourcesList,
  selectEventAvailableResourcesListTotalCount,
  selectEventResourcesList,
  eventResourcePending,
} from "src/engine/modules/eventResources/selectors"
import ResourceList from "./ResourceList"
import ResourceSelect from "./ResourceSelect"

const Resources = ({
  eventUuid,
  isNew,
  isDisabled,
  isResourcesDisabled,
  pending,
  getTestAttribute,
  allowedResourceTypes,
  allowedResourceTypesByStatus,
  readEventResourcesList,
  resetEventResourcesList,
  readEventAvailableResourcesList,
  addEventResource,
  deleteEventResource,
  availableList,
  availableTotal,
  resourcesList,
}) => {
  const [availableQuery, setQuery] = useState({
    limit: 30,
    offset: 0,
    query: `resourceTypeId=in=(${allowedResourceTypes})`,
    // query есть, но нет
  })
  useEffect(() => {
    if (eventUuid && !isNew) {
      resetEventResourcesList()
      readEventResourcesList({ uuid: eventUuid })
    }
  }, [eventUuid])
  useEffect(() => {
    if (eventUuid && !isNew) {
      readEventAvailableResourcesList({
        uuid: eventUuid,
        availableQuery,
      })
    }
  }, [eventUuid, availableQuery])
  return (
    <div>
      <ResourceSelect
        eventUuid={eventUuid}
        isNew={isNew}
        isDisabled={isDisabled}
        isResourcesDisabled={isResourcesDisabled}
        getTestAttribute={getTestAttribute}
        availableList={availableList}
        availableTotal={availableTotal}
        addEventResource={addEventResource}
        availableQuery={availableQuery}
        setQuery={setQuery}
        allowedResourceTypes={allowedResourceTypes}
        pending={pending}
      />
      {!isNew && (
        <ResourceList
          eventUuid={eventUuid}
          isDisabled={isDisabled}
          isResourcesDisabled={isResourcesDisabled}
          getTestAttribute={getTestAttribute}
          resourcesList={resourcesList}
          deleteEventResource={deleteEventResource}
          availableQuery={availableQuery}
          allowedResourceTypesByStatus={allowedResourceTypesByStatus}
          pending={pending}
        />
      )}
    </div>
  )
}

export default connect(
  state => ({
    availableList: selectEventAvailableResourcesList(state),
    availableTotal: selectEventAvailableResourcesListTotalCount(state),
    resourcesList: selectEventResourcesList(state),
    pending: eventResourcePending(state),
  }),
  {
    readEventResourcesList,
    resetEventResourcesList,
    readEventAvailableResourcesList,
    addEventResource,
    deleteEventResource,
  },
)(Resources)
